import { forwardRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import type {
  TDialogTriggerElement,
  TDialogTriggerProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";

export const DialogTrigger = forwardRef<TDialogTriggerElement, TDialogTriggerProps>(
  (props, ref) => (
    <DialogPrimitive.Trigger
      data-component="DialogTrigger"
      ref={ref}
      {...props}
    />
  ),
);

DialogTrigger.displayName = DialogPrimitive.Trigger.displayName;
